/**
 * @generated SignedSource<<a01e883b0c66d5b644570157bdcea210>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Mutation } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type UJStatuses = "OBSOLETE" | "PAUSED" | "RUNNING" | "%future added value";
export type selfServiceStatusSetStatusMutation$variables = {
  status: UJStatuses;
  ujID: number;
};
export type selfServiceStatusSetStatusMutation$data = {
  readonly setSelfServiceUJStatus: {
    readonly userJourney: {
      readonly " $fragmentSpreads": FragmentRefs<"selfServiceStatus_statusFragment">;
    } | null;
  } | null;
};
export type selfServiceStatusSetStatusMutation = {
  response: selfServiceStatusSetStatusMutation$data;
  variables: selfServiceStatusSetStatusMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "status"
},
v1 = {
  "defaultValue": null,
  "kind": "LocalArgument",
  "name": "ujID"
},
v2 = [
  {
    "fields": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "ujID"
      },
      {
        "kind": "Variable",
        "name": "status",
        "variableName": "status"
      }
    ],
    "kind": "ObjectValue",
    "name": "uj"
  }
];
return {
  "fragment": {
    "argumentDefinitions": [
      (v0/*: any*/),
      (v1/*: any*/)
    ],
    "kind": "Fragment",
    "metadata": null,
    "name": "selfServiceStatusSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetSelfServiceUJStatusMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "args": null,
                "kind": "FragmentSpread",
                "name": "selfServiceStatus_statusFragment"
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Mutation",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [
      (v1/*: any*/),
      (v0/*: any*/)
    ],
    "kind": "Operation",
    "name": "selfServiceStatusSetStatusMutation",
    "selections": [
      {
        "alias": null,
        "args": (v2/*: any*/),
        "concreteType": "SetSelfServiceUJStatusMutation",
        "kind": "LinkedField",
        "name": "setSelfServiceUJStatus",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "UserJourney",
            "kind": "LinkedField",
            "name": "userJourney",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "id",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "status",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "1096072024cd180fe65a62ef178ef33f",
    "id": null,
    "metadata": {},
    "name": "selfServiceStatusSetStatusMutation",
    "operationKind": "mutation",
    "text": "mutation selfServiceStatusSetStatusMutation(\n  $ujID: Int!\n  $status: UJStatuses!\n) {\n  setSelfServiceUJStatus(uj: {id: $ujID, status: $status}) {\n    userJourney {\n      ...selfServiceStatus_statusFragment\n      id\n    }\n  }\n}\n\nfragment selfServiceStatus_statusFragment on UserJourney {\n  id\n  status\n}\n"
  }
};
})();

(node as any).hash = "c62011635f26f48bde02ebbb0d157486";

export default node;
